// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1LaIz","selected":"Chip_selected__VUCpC"};